import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { RoutesService } from './routes.service';
import { CookieService } from './cookie';
import { CacheService } from './cache.service';

@Injectable()
export class RoutesBrowserService extends RoutesService {

  constructor(protected router: Router,
              protected translate: TranslateService,
              @Inject('CookieService') protected cookie: CookieService,
              protected location: Location,
              protected cache: CacheService) {
    super(router, translate, cookie, location, true, cache);

    this.browserLangs = RoutesBrowserService.getBrowserLangs();
  }

  public loadRoutes() {
    let lang = this.getLang();
    let requestUrl = `/assets/i18n-routes/${lang}.json`;
    let rawRoutes = this.cache.get(requestUrl);
    let routes = this.getRoutesWithComponents(rawRoutes);
    this.router.resetConfig(routes);
    this.cache.set(requestUrl, rawRoutes);
    this.cookie.put(RoutesService.COOKIE_LANG_KEY, lang);
  }

  private static getBrowserLangs(): string[] {
    let browserLangs = window.navigator['languages'] || null;
    browserLangs = browserLangs ||
      (window.navigator.language && [window.navigator.language]) ||
      (window.navigator['browserLanguage'] && [window.navigator['browserLanguage']]) ||
      (window.navigator['userLanguage'] && [window.navigator['userLanguage']]);
    return browserLangs.map((lang) => {
      if (lang.indexOf('-') !== -1) {
        return lang.split('-')[0];
      }
      if (lang.indexOf('_') !== -1) {
        return lang.split('_')[0];
      }
      return lang;
    });
  }

  public getRoutes()
  {
    let lang = this.getLang();
    let requestUrl = `/assets/i18n-routes/${lang}.json`;
    let rawRoutes = this.cache.get(requestUrl);

    return rawRoutes;
  }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/routes-browser.service.ts